// WAIT FOR UPCART LOAD
const waitForUpCart = setInterval(() => {
  const el = document.querySelector('#upCart');

  if (el && el.shadowRoot) {
    clearInterval(waitForUpCart);
    injectUpCartStyle(el.shadowRoot);
    initUpCartObserver(el);
  }
}, 1000);

// INIT OBSERVER (OPEN / CLOSE)
function initUpCartObserver(upCart) {
  const shadow = upCart.shadowRoot;
  const cart = shadow.querySelector('#CartPopup');
  if (!cart) return;

  let wasOpen = false;

  const observer = new MutationObserver(() => {
    const isOpen = cart.classList.contains('styles_active__');

    if (isOpen && !wasOpen) {
      console.log('Mini cart OPEN');
      handleCpOnCartDrawer(shadow);
      attachCheckoutBtnEvent(shadow);

      setTimeout(() => {
        const upCart = document.querySelector('#upCart');
        const shadow = upCart?.shadowRoot;
        shadow.addEventListener('click', (e) => {
            const btnChange = shadow.querySelector(
              '.upcart-product-quantity-minus, .upcart-product-quantity-plus, .upcart-internal-component-product-tile__quantity-minus, .upcart-internal-component-product-tile__quantity-plus'
            );

            if (btnChange) {
              console.log('Qty changed');
              setTimeout(() => {
                handleCpOnCartDrawer(shadow);
                attachCheckoutBtnEvent(shadow);
              }, 2000);
            }
        });
      }, 300);
      
      setTimeout(() => {
          handleUpsellProducts(shadow);
      }, 500);

      const checkBtnInterval = setInterval(() => {
        const btn = shadow.querySelector(".upcart-checkout-button");
        if (btn) {
          clearInterval(checkBtnInterval);
          const newBtn = btn.cloneNode(true);
          btn.parentNode.replaceChild(newBtn, btn);

          // new event
          newBtn.addEventListener("click", function(e) {
            e.preventDefault();
            console.log("Checkout clicked");
            BSS_B2B.observer.cartSubject.notifyObserver('CartCheckout', 'ClickCheckout');
          });
        }
      }, 500);
    }

    wasOpen = isOpen;
  });

  observer.observe(cart, {
    attributes: true,
    attributeFilter: ['class'],
  });
}

// WAIT FOR CART ITEMS RENDER
function waitForItems(shadow) {
  return new Promise((resolve) => {
    const interval = setInterval(() => {
      const nodes = shadow.querySelectorAll('.upcart-product-item, .upcart-internal-cart-item');

      if (nodes.length > 0) {
        clearInterval(interval);
        resolve(nodes);
      }
    }, 100);
  });
}

// MAIN HANDLE FUNCTION
async function handleCpOnCartDrawer(shadow) {
  try {
    const res = await fetch('/cart.js');
    const data = await res.json();
    const nodes = await waitForItems(shadow);

    // MAP ITEMS (index-based)
    data.items.forEach((item, i) => {
      const node = nodes[i];
      if (!node) return;

      const moneyNode = node.querySelector('.upcart-item-prices-row, .upcart-internal-component-product-tile__product-pricing');

      if (moneyNode) {
        moneyNode.setAttribute('bss-b2b-cart-item-key', item.key);
        moneyNode.setAttribute('bss-b2b-final-line-price', '');
      }
    });

    // SUBTOTAL
    // const subtotalNode = shadow.querySelector(
    //   '.upcart-checkout-button-container .transcy-money'
    // );

    // if (subtotalNode) {
    //   subtotalNode.setAttribute('bss-b2b-cart-total-price', '');
    // }

    // SUBTOTAL
const checkoutBtn = shadow.querySelector(
  '.upcart-checkout-button-container a.upcart-checkout-button'
);

if (checkoutBtn) {
  const text = checkoutBtn.textContent.trim();

  // Tách phần giá (giả sử format có dấu •)
  const [label, price] = text.split('•').map(t => t.trim());

  // Clear nội dung cũ
  checkoutBtn.innerHTML = '';

  // Tạo label node
  const labelNode = document.createElement('span');
  labelNode.textContent = label + ' • ';

  // Tạo price node riêng
  const priceNode = document.createElement('span');
  priceNode.classList.add('bss-subtotal-price');
  priceNode.textContent = price;

  // Gắn attribute cần thiết
  priceNode.setAttribute('bss-b2b-cart-total-price', '');

  // Append lại
  checkoutBtn.appendChild(labelNode);
  checkoutBtn.appendChild(priceNode);
}

    BSS_B2B.observer.cartSubject.notifyObserver('CartMutate', 'CartPriceMutate');  

    setTimeout(async () => {
      const res1 = await fetch('/cart.js');
      const data1 = await res1.json();
      const nodes1 = await waitForItems(shadow);

      // MAP ITEMS (index-based)
      data1.items.forEach((item, i) => {
        const node = nodes1[i];
        if (!node) return;

        const moneyNode = node.querySelector('.upcart-item-prices-row, .upcart-internal-component-product-tile__product-pricing');

        if (moneyNode) {
          moneyNode.setAttribute('bss-b2b-cart-item-key', item.key);
          moneyNode.setAttribute('bss-b2b-final-line-price', '');
        }
      });

      // SUBTOTAL
      // const subtotalNode1 = shadow.querySelector(
      // '.upcart-checkout-button-container .transcy-money'
      // );
      // if (subtotalNode1) {
      //   subtotalNode1.setAttribute('bss-b2b-cart-total-price', '');
      // }

      // SUBTOTAL
const checkoutBtn = shadow.querySelector(
  '.upcart-checkout-button-container a.upcart-checkout-button'
);

if (checkoutBtn) {
  const text = checkoutBtn.textContent.trim();

  // Tách phần giá (giả sử format có dấu •)
  const [label, price] = text.split('•').map(t => t.trim());

  // Clear nội dung cũ
  checkoutBtn.innerHTML = '';

  // Tạo label node
  const labelNode = document.createElement('span');
  labelNode.textContent = label + ' • ';

  // Tạo price node riêng
  const priceNode = document.createElement('span');
  priceNode.classList.add('bss-subtotal-price');
  priceNode.textContent = price;

  // Gắn attribute cần thiết
  priceNode.setAttribute('bss-b2b-cart-total-price', '');

  // Append lại
  checkoutBtn.appendChild(labelNode);
  checkoutBtn.appendChild(priceNode);
}

      BSS_B2B.observer.cartSubject.notifyObserver('CartMutate', 'CartPriceMutate');  

      const checkBtnInterval = setInterval(() => {
        const btn = shadow.querySelector(".upcart-checkout-button");
        if (btn) {
          clearInterval(checkBtnInterval);
          const newBtn = btn.cloneNode(true);
          btn.parentNode.replaceChild(newBtn, btn);

          // new event
          newBtn.addEventListener("click", function(e) {
            e.preventDefault();
            BSS_B2B.observer.cartSubject.notifyObserver('CartCheckout', 'ClickCheckout');
          });
        }
      }, 500);
    }, 2000);
  } catch (err) {
    console.error('Cart handle error:', err);
  }
}

function handleUpsellProducts(shadow) {
  const slides = shadow.querySelectorAll('#up-upsell-carousel .slide, .upcart-public-component-carousel__slide');

  slides.forEach((slide) => {
    const link = slide.querySelector('a[href*="/products/"]');
    const priceEle = slide.querySelector(
      '.upcart-upsell-item-price-row, .upcart-internal-component-upsell-tile__price-row'
    );

    if (!link || !priceEle) return;

    const href = link.getAttribute('href');

    const match = href.match(/(?:pr_rec_pid|pid)=(\d+)/);
    if (!match) return;

    const pID = match[1];

    priceEle.setAttribute('bss-b2b-product-id', pID);
    priceEle.setAttribute('bss-b2b-product-price', 'true');
  });
}

function injectUpCartStyle(shadow) {
  if (shadow.querySelector('#bss-custom-style')) return;

  const style = document.createElement('style');
  style.id = 'bss-custom-style';

  style.innerHTML = `
    .upcart-item-prices-row[bss-b2b-final-line-price],
    .upcart-internal-component-product-tile__product-pricing[bss-b2b-final-line-price] {
      color: #003266 !important;
      font-size: 15px !important;
      font-weight: 500 !important;
    }
  `;

  shadow.appendChild(style);
}

function attachCheckoutBtnEvent(shadow) {
  const btn = shadow.querySelector(".upcart-checkout-button");
  if (!btn) return;

  // tránh bind nhiều lần
  if (btn.__bss_bound) return;

  const newBtn = btn.cloneNode(true);
  btn.parentNode.replaceChild(newBtn, btn);

  newBtn.__bss_bound = true;

  newBtn.addEventListener("click", function(e) {
    e.preventDefault();
    BSS_B2B.observer.cartSubject.notifyObserver('CartCheckout', 'ClickCheckout');
  });
}